
import { createReducer } from 'redux-act';
import update from 'immutability-helper';

import { load_table, load_complex_table, set_locale } from '../actions';

export default createReducer({
  [load_table]: 
  	(state, { table, payload }) => update(state, { [table]: { $set: payload } }),
  [load_complex_table]:
  	(state, { table, type, payload }) => {
  		if(table in state)
  			return update(state, { [table]: { [type]: { $set: payload } } });
  		else
  			return update(state, { [table]: { $set: { [type]: payload } } });
  	},
  [set_locale]: 
		(state) => ({}), // Clear LUTs when changing the languige
}, { });
